export const beautifyURL = (url) => {
  let nextUrl = url
  // Remove trailing slash
  nextUrl = nextUrl.replace(/\/$/, '')
  // Remove protocol
  nextUrl = nextUrl.replace(/^https?:\/\//i, '')
  // Remove www.
  nextUrl = nextUrl.replace(/^www\./i, '')
  return nextUrl
}

export const normalizeURL = url => (
  /^https?:\/\//i.test(url) ? url : `http://${url}`
)
